import React, { useState } from 'react';
import {
  Modal, Form, Input, Button, Row, Col, Table, message,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { getCiudadanoPublic } from 'api/cuentaunicasir';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import Moment from 'moment';
import PropTypes from 'prop-types';
import { nameValidationSearch } from 'utils/nameValidationSearch';
import { selectPublicoGeneral } from 'store/auth';
import { useSelector } from 'react-redux';

const BusquedaAvanzadaCiudadano = ({ visible, onCancel, onSelect }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const pg = useSelector(selectPublicoGeneral);

  const handleSearch = async (page = 1, q = null, ignore = false) => {
    try {
      setLoading(true);
      const values = form.getFieldsValue();
      const keys = Object.keys(values);
      const validProps = keys.filter((prop) => values[prop]);
      const validationName = nameValidationSearch(validProps);

      if (!(validProps.length || ignore)) {
        message.warning('Debe ingresar al menos un campo');
        setLoading(false);
        return;
      }

      if (!validationName) {
        message.warning('Debe ingresar mínimo dos campos referentes a nombre');
        setLoading(false);
        return;
      }

      const results = await getCiudadanoPublic({
        page,
        ...values,
        ...{ ...q },
      });

      const _data = results?.results || results || [];
      const filtered = _data.filter((item) => item.id !== pg);

      if (filtered.length) {
        setData(filtered);
      } else {
        message.warning(`No se encontró ningún ciudadano relacionado.
        ${_data.some((item) => item.id === pg)
    ? 'Recuerde que el público general no está disponible en las búsquedas.'
    : ''
}`);
      }

      setLoading(false);
    } catch (err) {
      message.error('Error al buscar ciudadano');
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Nombre Completo',
      dataIndex: 'nombre_completo',
      key: 'nombre_completo',
    },
    {
      title: 'CURP',
      dataIndex: 'CURP',
      key: 'CURP',
    },
    {
      title: 'RFC',
      dataIndex: 'RFC',
      key: 'RFC',
    },
    {
      title: 'Fecha Nacimiento',
      dataIndex: 'fecha_nacimiento',
      key: 'fecha_nacimiento',
      render: (val) => (val ? Moment(val).format(DATE_FRONTEND_FORMAT) : ''),
    },
    {
      title: 'Seleccionar',
      dataIndex: 'id',
      key: 'seleccionar',
      render: (_, record) => (
        <Button onClick={() => {
          onSelect(record);
          form.resetFields();
          setData([]);
        }}
        >
          Seleccionar
        </Button>
      ),
    },
  ];

  return (
    <Modal
      visible={visible}
      onCancel={() => {
        onCancel();
        form.resetFields();
        setData([]);
      }}
      title="Búsqueda Avanzada de Ciudadano"
      footer={null}
      width="80%"
    >
      <Form form={form} layout="vertical" onFinish={handleSearch}>
        <Row gutter={10}>
          <Col span={6}>
            <Form.Item label="Nombre" name="nombre">
              <Input />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Apellido Paterno" name="apellido_paterno">
              <Input />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Apellido Materno" name="apellido_materno">
              <Input />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="CURP" name="CURP">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="end">
          <Button htmlType="submit" icon={<SearchOutlined />} loading={loading}>
            Buscar
          </Button>
        </Row>
      </Form>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={false}
        style={{ marginTop: 20 }}
      />
    </Modal>
  );
};
BusquedaAvanzadaCiudadano.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default BusquedaAvanzadaCiudadano;
